"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortationGaylordError = exports.SortationGaylordStatus = void 0;
var SortationGaylordStatus;
(function (SortationGaylordStatus) {
    SortationGaylordStatus["CREATED"] = "CREATED";
    SortationGaylordStatus["REGISTERED_FOR_PACKAGES"] = "REGISTERED_FOR_PACKAGES";
    SortationGaylordStatus["LEFT_IN_BUILDING"] = "LEFT_IN_BUILDING";
    SortationGaylordStatus["ASSIGNED_TO_DOCK_DOOR"] = "ASSIGNED_TO_DOCK_DOOR";
})(SortationGaylordStatus = exports.SortationGaylordStatus || (exports.SortationGaylordStatus = {}));
var SortationGaylordError;
(function (SortationGaylordError) {
    SortationGaylordError["CARRIER_MISSORT"] = "CARRIER_MISSORT";
    SortationGaylordError["INVALID_NUM_GAYLORDS_TO_CREATE"] = "INVALID_NUM_GAYLORDS_TO_CREATE";
    SortationGaylordError["NOT_FOUND"] = "NOT_FOUND";
    SortationGaylordError["MISSING_GAYLORD_SORT_CODE"] = "MISSING_GAYLORD_SORT_CODE";
    SortationGaylordError["GAYLORD_DOCK_DOOR_MISMATCH"] = "GAYLORD_DOCK_DOOR_MISMATCH";
    SortationGaylordError["DOCK_DOOR_MAPPING_NOT_FOUND"] = "DOCK_DOOR_MAPPING_NOT_FOUND";
    SortationGaylordError["INVALID_LIB_REASON"] = "INVALID_LIB_REASON";
})(SortationGaylordError = exports.SortationGaylordError || (exports.SortationGaylordError = {}));
//# sourceMappingURL=SortationGaylord.js.map